import Vue from "vue";

export const captchaState = Vue.observable({
  verified: false,
  widgetId: null
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export function hasCaptchaToken() {
  return !!getCookie('captcha_verified');
}

export function saveCaptchaToken(token) {
  const date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `captcha_verified=${token}; ${expires}; path=/; SameSite=Lax`;
  captchaState.verified = true;
}

export function initSmartCaptcha(siteKey) {
  if (captchaState.widgetId !== null) {
    return captchaState.widgetId;
  }
  const container = document.getElementById("smart-captcha");

  if (typeof window.smartCaptcha === 'undefined' || !container) {
    return null;
  }

  if(process.env.VUE_APP_YANDEX_CAPTCHA_ACTIVE === "false") {
    return captchaState.verified = true;
  }

  try {
    const widgetId = window.smartCaptcha.render("smart-captcha", {
      sitekey: siteKey,
      invisible: true, 
      hideShield: true, 
      callback: (token) => {
        saveCaptchaToken(token);
      },
    });

    if (widgetId) {
      captchaState.widgetId = widgetId;
      window.smartCaptcha.execute(widgetId);
    }

    return widgetId;
  } catch (error) {
    console.warn('SmartCaptcha init error:', error);
    return null;
  }
}

captchaState.verified = hasCaptchaToken();